import * as React from 'react';
import styled from 'styled-components';

const Placeholder = styled.div`
  flex: 1 0 48%;
  margin-bottom: 15px;
  margin-right: 20px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-sizing: border-box;
  @media screen and (min-width: 52em) {
    flex: 1 0 23%;
  }
`;

const EmptyPlaceholder: React.FC = props => {
  return (
    <Placeholder>
      {props.children}
    </Placeholder>
  );
};

export default EmptyPlaceholder;



// WEBPACK FOOTER //
// ./src/components/formElements/EmptyPlaceholder.tsx